const config = {
  apiBaseUrl: 'https://staging.zeely.link/'
  // apiBaseUrl: 'https://dev.zeely.link/',
};

export default config;
